
<div class="container-elements" #carchivedelements>
  <div *ngFor="let r of reset">
    <ng2-smart-table [settings]="settings" (custom)="unhideElement($event)" [source]="elementSource" >
    </ng2-smart-table>
  </div>

</div>
